import React from 'react'
import PropTypes from 'prop-types'
import NoteComposer from './note-composer'
import { buildSessionNoteTitle } from './session-note-utils'

function SessionNoteInlineForm({
  mode,
  sessionId,
  sessionTitle,
  sessionDate,
  timezone,
  studentFirstName,
  note,
  onSubmit,
  onCancel,
  isSubmitting,
  embedded,
  heading,
}) {
  const defaultTitle =
    mode === 'create'
      ? buildSessionNoteTitle(sessionTitle, sessionDate, timezone)
      : ''

  const resolveNoteTitle = trimmedTitle => {
    if (trimmedTitle) return trimmedTitle
    if (mode === 'create') {
      return buildSessionNoteTitle(sessionTitle, sessionDate, timezone)
    }
    return null
  }

  const handleSubmit = data => {
    const title = resolveNoteTitle(data.title)

    if (mode === 'create') {
      onSubmit({
        notableId: sessionId,
        notableType: 'Session',
        title,
        content: data.content,
        private: data.isPrivate,
      })
      return
    }

    onSubmit({
      id: note.id,
      title,
      content: data.content,
      private: data.isPrivate,
    })
  }

  const resolvedHeading =
    heading !== undefined
      ? heading
      : mode === 'edit'
        ? 'Edit note'
        : 'Add a note'

  return (
    <NoteComposer
      heading={resolvedHeading}
      mode={mode}
      isEditing={mode === 'edit'}
      note={note}
      studentFirstName={studentFirstName}
      defaultTitle={defaultTitle}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      isSubmitting={isSubmitting}
      embedded={embedded}
    />
  )
}

SessionNoteInlineForm.propTypes = {
  mode: PropTypes.oneOf(['create', 'edit']).isRequired,
  sessionId: PropTypes.string.isRequired,
  sessionTitle: PropTypes.string,
  sessionDate: PropTypes.string,
  timezone: PropTypes.string,
  studentFirstName: PropTypes.string,
  note: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    content: PropTypes.string,
    private: PropTypes.bool,
  }),
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  isSubmitting: PropTypes.bool,
  embedded: PropTypes.bool,
  heading: PropTypes.oneOfType([PropTypes.string]),
}

SessionNoteInlineForm.defaultProps = {
  sessionTitle: null,
  sessionDate: null,
  timezone: null,
  studentFirstName: null,
  note: null,
  onCancel: null,
  isSubmitting: false,
  embedded: true,
  heading: undefined,
}

export default SessionNoteInlineForm
